module.exports = __webpack_public_path__ + "img/plant_4_mobile.e99f6c71.webp";